import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dataFilter",
})
export class DataFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.name.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "nameFilter",
})
export class NameFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.user_id.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "regiscamFilter",
})
export class RegisCamFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(
        array,
        (row) =>
          row.imei.indexOf(query) > -1 ||
          row.plate_number.indexOf(query) > -1 ||
          row.serial_sim.indexOf(query) > -1 ||
          row.sim.indexOf(query) > -1 ||
          row.blackbox_id.indexOf(query) > -1 ||
          row.email.indexOf(query) > -1 ||
          row.server.indexOf(query) > -1
      );
    }
    return array;
  }
}

@Pipe({
  name: "usernamenameFilter",
})
export class UserNameFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.username.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "rowFilter",
})
export class RowFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.imei.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "groupFilter",
})
export class GroupFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.groupname.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "plateFilter",
})
export class PlateFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => row.plate_number.indexOf(query) > -1);
    }
    return array;
  }
}

@Pipe({
  name: "realtimefilter",
})
export class UniFilterPipe implements PipeTransform {
  transform(array: any[], query: string): Array<any> {
    if (query) {
      return _.filter(
        array,
        (row) =>
          row.imei.indexOf(query) > -1 || row.plate_number.indexOf(query) > -1 || row.timestamp.indexOf(query) > -1 || row.warning_text.indexOf(query) > -1
      );
    }
    return array;
  }
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/elements/data-filter.pipe.ts